export const transactions = {
  INDEX: '/transactions/list',
}
